import { render } from "./Area.vue?vue&type=template&id=54b884fe"
import script from "./Area.vue?vue&type=script&lang=js"
export * from "./Area.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/buildings/Area.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54b884fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54b884fe', __exports__)) {
    api.reload('54b884fe', __exports__)
  }
  
  module.hot.accept("./Area.vue?vue&type=template&id=54b884fe", () => {
    api.rerender('54b884fe', render)
  })

}


export default __exports__